'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sentqueries = require('./sentqueries.html');

var _sentqueries2 = _interopRequireDefault(_sentqueries);

var _sentqueries3 = require('./sentqueries.controller');

var _sentqueries4 = _interopRequireDefault(_sentqueries3);

require('./sentqueries.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sentqueriesComponent = {
  restrict: 'E',
  bindings: {},
  template: _sentqueries2.default,
  controller: _sentqueries4.default,
  controllerAs: 'vm'
};

exports.default = sentqueriesComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/sentqueries/sentqueries.component.js